    <nb-tabset (changeTab)="onChangeTab($event)">
      <nb-tab tabTitle="Consulta" tabIcon="search-outline" responsive style="height: 80vh;">
        <p class="Titulo">Consulta - Severidad</p>
          <button nbButton shape="round" size="small" class="buttontz float-left" style="margin-bottom: 10px;" (click)="consultarSeveridadConsulta()">
            <nb-icon nbPrefix icon="refresh-outline"></nb-icon>
          </button>
        <app-spinner *ngIf="showSpinnerConsulta"></app-spinner>
        <div *ngIf="showGrillaConsulta">
          <!-- <angular-slickgrid gridId="gridSeveridadConsulta"
              [columnDefinitions]="columnDefinitionsSeveridadConsulta"
              [gridOptions]="gridOptionsSeveridadConsulta" 
              [dataset]="datasetSeveridadConsulta" 
              gridHeight="380"
              gridWidth="100%"
              (onAngularGridCreated)="angularGridReadySeveridadConsulta($event)">
           </angular-slickgrid> -->

            <ag-grid-angular
            #grilla1
            class="ag-theme-alpine"
            style="width: 100%; height: 380px;"
            [rowData]="datasetSeveridadConsulta"
            [columnDefs]="columnDefinitionsSeveridadConsulta"
            (gridReady)="onGridReady($event)" 
            [enableCellTextSelection]="true"/>
        </div>
        <button nbButton size="tiny" style="float: right; margin-top: 50px;" class=" buttontz" [hidden]="!showGrillaConsulta" [disabled]="!showGrillaConsulta"
            (click)="exportToExcelSeveridad()" ><nb-icon icon="save-outline"></nb-icon>Exportar</button>
      </nb-tab>
      <nb-tab *ngIf="usersRol.GESTIONAR_PARAMETROS_SISTEMA" tabTitle="Alta" tabIcon="upload-outline" responsive style="height: 80vh;">
        <div class="row">
          <div class="col-4 float-left">
            <p class="Titulo">Alta Severidad</p>
            <p>
              <mat-form-field class="altaLabel">
                <mat-label>Ingresar Descripción</mat-label>
                <input matInput #message1 maxlength="80" [(ngModel)]="descripcionSeveridad" name="descripcion">
                <mat-hint align="end">{{message1.value.length}} / 80</mat-hint>
              </mat-form-field>
            </p>
            <p>
              <mat-form-field class="altaLabel">
                <mat-label>Ingresar Descripción Breve</mat-label>
                <input matInput #message2 maxlength="40" [(ngModel)]="descripcionBreve" name="breve">
                <mat-hint align="end">{{message2.value.length}} / 40</mat-hint>
              </mat-form-field>
            </p>
            <p>
              <mat-form-field class="altaLabel">
                <mat-label>Ingresar Código Externo</mat-label>
                <input matInput #message3 maxlength="40" [(ngModel)]="codigoExterno" name="codigo">
                <mat-hint align="end">{{message3.value.length}} / 40</mat-hint>
              </mat-form-field>
            </p>
            <p>
              <app-spinner *ngIf="showSpinnerGuardar"></app-spinner>
              <button *ngIf="!showSpinnerGuardar" nbButton size="tiny" status="primary" class="buttontz" (click)="altaSeveridad()">Guardar</button>
            </p>
          </div>
          <div>
            <button nbButton shape="round" size="small" class="buttontz float-right" (click)="consultarSeveridad()">
              <nb-icon nbPrefix icon="refresh-outline"></nb-icon>
            </button>
          </div>
          <app-spinner class="col-6" *ngIf="showSpinner"></app-spinner>
          <div *ngIf="showGrilla" class="col-6">
            <!-- <angular-slickgrid gridId="gridSeveridad"
                [columnDefinitions]="columnDefinitionsSeveridad"
                [gridOptions]="gridOptionsSeveridad" 
                [dataset]="datasetSeveridad" 
                gridHeight="380"
                (onAngularGridCreated)="angularGridReadySeveridad($event)">
             </angular-slickgrid> -->
             <ag-grid-angular
              #grilla2
              class="ag-theme-alpine"
              style="width: 100%; height: 380px;"
              [rowData]="datasetSeveridad"
              [columnDefs]="columnDefinitionsSeveridad"
              (gridReady)="onGridReady($event)" 
            [enableCellTextSelection]="true"/>
          </div>
        </div>

      </nb-tab>
      <nb-tab *ngIf="usersRol.GESTIONAR_PARAMETROS_SISTEMA" tabTitle="Modificación" tabIcon="edit-outline" responsive style="height: 75vh;">
        <p class="Titulo">Modificar Severidad</p>
        <div class="row">
          <div class="col-4 float-left">
            <p-dropdown required class="limited-selector" id="inputTipo" placeholder="Seleccionar Severidad"
              [style]="{'width':'100%','margin-bottom':'10px', 'margin-top':'10px'}" [options]="severidad"
              [(ngModel)]="severidadProcesado" (onChange)="obtenerDescripcionDropdown(severidadProcesado)" [virtualScroll]="true"
              [itemSize]="31" [filter]="true"
              [ngClass]="{'form-control-danger': firstForm.invalid && (firstForm.dirty || firstForm.touched)}">
            </p-dropdown>
            <div>
              <p>
                <mat-form-field class="altaLabelModificar">
                  <mat-label>Descripcion</mat-label>
                  <input matInput #message4 maxlength="80" [(ngModel)]="descripcionSeveridadEditar" name="descripcionSeveridadEditar">
                  <mat-hint align="end">{{message4.value.length}} / 80</mat-hint>
                </mat-form-field>
              </p>
              <p>
                <mat-form-field class="altaLabelModificar">
                  <mat-label>Descripcion Breve</mat-label>
                  <input matInput #message5 maxlength="40" [(ngModel)]="descripcionBreveEditar"
                    name="descripcionBreveEditar">
                  <mat-hint align="end">{{message5.value.length}} / 40</mat-hint>
                </mat-form-field>
              </p>
              <p>
                <mat-form-field class="altaLabelModificar">
                  <mat-label>Código Externo</mat-label>
                  <input matInput #message6 maxlength="40" [(ngModel)]="codigoExternoEditar" name="codigoExternoEditar">
                  <mat-hint align="end">{{message6.value.length}} / 40</mat-hint>
                </mat-form-field>
              </p>
              <p>
                <nb-checkbox (checkedChange)="toggleEliminar($event)" [(ngModel)]="eliminarSeleccionado">Eliminar</nb-checkbox>
              </p>
              <p>
                <app-spinner *ngIf="showSpinnerModificar"></app-spinner>
                <button *ngIf="!showSpinnerModificar" nbButton size="tiny" status="primary" class="buttontz" (click)="modificarSeveridad()">Modificar</button>
              </p>
            </div>
          </div>
          <div class="col-8 float-right">
            <app-spinner class="col-6" *ngIf="showSpinnerModificarGrilla"></app-spinner>
          <div *ngIf="showGrillaModificar">
            <!-- <angular-slickgrid gridId="gridSeveridadModificar"
                [columnDefinitions]="columnDefinitionsSeveridadModificar"
                [gridOptions]="gridOptionsSeveridadModificar" 
                [dataset]="datasetSeveridadModificar" 
                gridHeight="380"
                (onAngularGridCreated)="angularGridReadySeveridadModificar($event)">
             </angular-slickgrid> -->
             <ag-grid-angular
              #grilla3
              class="ag-theme-alpine"
              style="width: 100%; height: 380px;"
              [rowData]="datasetSeveridadModificar"
              [columnDefs]="columnDefinitionsSeveridadModificar"
              (gridReady)="onGridReady($event)" 
              [enableCellTextSelection]="true"/>
          </div>
          </div>
        </div>
      </nb-tab>
    </nb-tabset>